import { EventDetailsResponse } from '../models/api';
import { getData } from './api';
import { ResponseData } from './models';

export const list = async (): Promise<ResponseData<EventDetailsResponse>> =>
  getData<EventDetailsResponse>('api/events');
